import { Component } from '@angular/core';
import { IconComponent } from '@examdojo/core/icon';
import { MarkdownViewerComponent } from '@examdojo/ui/markdown-viewer';
import { BasicQuadraticCalculatorComponent } from './calculators/basic-quadratic-calculator';

@Component({
  selector: 'exam-quadratic-functions',
  standalone: true,
  imports: [IconComponent, MarkdownViewerComponent, BasicQuadraticCalculatorComponent],
  templateUrl: './quadratic-functions.component.html',
  styleUrls: ['./quadratic-functions.component.scss'],
  host: { class: 'block h-full w-full overflow-y-auto bg-neutral-0' },
})
export class QuadraticFunctionsComponent {}
